import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, ReplaySubject, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {User} from '../models/user';
import {HttpClient} from '@angular/common/http';
// import {AuthService as SocialAuthService, FacebookLoginProvider, GoogleLoginProvider} from 'angularx-social-login';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private tokenSubject: Subject<string> = new ReplaySubject(1);

    get token$(): Observable<string> {
        return this.tokenSubject.asObservable();
    }

    private userSubject: BehaviorSubject<User> = new BehaviorSubject(null);

    get user$(): Observable<User> {
        return this.userSubject.asObservable();
    }

    get user(): User {
        return this.userSubject.value;
    }

    private token: string;
    private type: string;

    // constructor(private router: Router, private http: HttpClient, private social: SocialAuthService) {
    constructor(private router: Router, private http: HttpClient) {
        this.getDataFromStorage();
    }

    getDataFromStorage() {
        const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
        const type = sessionStorage.getItem('type') || localStorage.getItem('type');
        // const user = JSON.parse(sessionStorage.getItem('admin') || localStorage.getItem('admin'));
        this.tokenSubject.next(token || null);
        this.token = token;
        this.type = type;
        // this.userSubject.next(user);
    }

    async login(username: string, password: string) {
        if (!username || !password) {
            throw new Error('Invalid email or password');
        }

        const resp = await this.http.post<any>('auth/login', {username, password}).toPromise();
        this.handleLoginResponse(resp);
    }

    private handleLoginResponse(resp: any) {
        const {data, type} = resp;
        console.log(data, type, resp);
        localStorage.setItem('authToken', data);
        localStorage.setItem('type', type);
        // localStorage.setItem('admin', JSON.stringify(admin));
        this.tokenSubject.next(data);
        this.token = data;
        this.type = type;
        // this.userSubject.next(admin);
    }

    async logout() {
        // try {
        //     await this.social.signOut();
        // } catch (_) {
        // }
        await this.http.post('auth/logout', {}, {responseType: 'text'}).toPromise();
        this.clearLocalStorage();
    }

    async clearLocalStorage() {
        sessionStorage.clear();
        localStorage.clear();
        this.tokenSubject.next(null);
        // this.userSubject.next(null);
        this.token = null;
        this.type = null;
        await this.router.navigate(['']);
    }

    isLoggedIn() {
        return !!this.token;
    }

    userCan(action: string): boolean {
        // return false;
        //Super admin can do anything
        switch(this.type) {
            case 'superAdmin':
                return true;
            case 'admin':
                return ['dashboard:view', 'bookings:view', 'bookings:details', 'drivers:view', 'drivers:edit', 'drivers:edit:BoostPercentage', 'drivers:edit:driverToPlatformCommissionPercentage', 'drivers:sendPN', 'riders:view', 'operators:view', 'operators:edit', 'dispatches:view', 'invoices:view', 'invoices:markAsPaid', 'request-access:view', 'reviews:view', 'drivers:booking-stats', 'drivers:time-online', 'promos:view', 'admins:view', 'overview:view', 'refund', 'pushNotificationTopic', 'settings:view'].indexOf(action) >= 0
            case 'support':
                return ['bookings:view', 'bookings:details', 'drivers:view', 'drivers:sendPN', 'riders:view', 'promos:view', 'pushNotificationTopic'].indexOf(action) >= 0
            case 'finance':
                return ['drivers:view', 'riders:view', 'invoices:view', 'invoices:markAsPaid', 'refund'].indexOf(action) >= 0
            case 'managementDrivers':
                return ['bookings:view', 'bookings:details', 'drivers:view', 'drivers:edit', 'riders:view', 'operators:view', 'operators:edit', 'dispatches:view', 'invoices:view', 'invoices:markAsPaid', 'request-access:view', 'reviews:view', 'drivers:booking-stats', 'drivers:time-online', 'overview:view'].indexOf(action) >= 0
            case 'operator':
                return ['bookings:view', 'drivers:view', 'invoices:view'].indexOf(action) >= 0
        }

        return false;
    }
}
